import React, { useEffect, useState } from "react";
import axios from "~/config/axios";

import { WaitingListPopup } from "@obby/components";

export function JoinWaitingListPopup({ courseId, onClose, sessionId }: Props) {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState<Data>({
    course: undefined,
    session: undefined,
    location: undefined
  });
  const { session, course, location } = data;

  useEffect(() => {
    (async () => {
      const response = await axios.get(
        `/popups/waiting-list/${courseId}${sessionId ? `/${sessionId}` : ""}`
      );
      setData(response.data);
      setIsLoading(false);
    })();
  }, []);

  async function onSubmit(params: WaitingListPopup.SubmitParams) {
    const url = session
      ? `session/${session._id}/waiting-list`
      : `class/${course._id}/waiting-list`;
    return axios.post(url, {
      params
    });
  }

  return (
    !isLoading && (
      <WaitingListPopup
        course={course}
        location={location}
        onClose={onClose}
        onSubmit={onSubmit}
        session={session}
      />
    )
  );
}

interface Props {
  courseId: string;
  sessionId?: string;
  onClose: () => void;
}

interface Data {
  session: any;
  course: any;
  location: any;
}
